<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Profile</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$ && userMetadata">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Alapadatok</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-input labelPlacement="stacked" label="Vezetéknév" label-placement="floating" fill="outline"></ion-input>
          </ion-col>
          <ion-col>
            <ion-input labelPlacement="stacked" label="Keresztnév" label-placement="floating" fill="outline"></ion-input>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-input disabled labelPlacement="stacked" label="Felhasználónév" label-placement="floating" fill="outline"></ion-input>
          </ion-col>
          <ion-col>
            <ion-input type="email" labelPlacement="stacked" label="E-mail" label-placement="floating" fill="outline"></ion-input>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Jogkör</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-select fill="outline" interface="popover" label="Jogkör" labelPlacement="stacked" name="selectedMonth"
                    ><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
                      <ion-select-option value="1">Páciens</ion-select-option>
                      <ion-select-option value="2">Beteggondozó</ion-select-option>
                      <ion-select-option value="3">Klinikus</ion-select-option>
                      <ion-select-option value="4">Kutató</ion-select-option>
                      <ion-select-option value="5" disabled>Admin</ion-select-option>
                    </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Betegadatok</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-select fill="outline" interface="popover" label="Diagnózis" labelPlacement="stacked" name="selectedMonth"
                    ><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
                      <ion-select-option value="1">Cisztás fibrózis (CF) - ORPHA:586</ion-select-option>
                      <ion-select-option value="2">Neurofibromatózis I (NF1) - ORPHA:636</ion-select-option>
                      <ion-select-option value="3">Fenilketonúria (PKU) - ORPHA:716</ion-select-option>
                      <ion-select-option value="4">Duchenne-féle izomdisztrófia (DMD) - ORPHA:262</ion-select-option>
                      <ion-select-option value="5">Spinalis izomatrophia (SMA) - ORPHA:83418</ion-select-option>
                      <ion-select-option value="6">Hemofília A - ORPHA:98878</ion-select-option>
                      <ion-select-option value="7">Marfan-szindróma - ORPHA:558</ion-select-option>
                      <ion-select-option value="8">Huntington-kór - ORPHA:399</ion-select-option>
                      <ion-select-option value="9">Charcot-Marie-Tooth 1A (CMT 1A) - ORPHA:101081</ion-select-option>
                      <ion-select-option value="10">Pseudoxanthoma elasticum (PXE) - ORPHA:758</ion-select-option>
                    </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</ion-content>
